import React from 'react';
import { Section } from './ui/Section';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    num: '01',
    title: '100 Ejercicios con Descripción y Variantes',
    desc: 'Banco completo de 100 ejercicios organizados por categoría y nivel. Con variante más fácil, más difícil, músculos trabajados y reps recomendadas para WODs. Tu referencia técnica permanente.',
    value: '$12.000'
  }, {
    num: '02',
    title: 'Plantilla de Clase Lista para Imprimir',
    desc: 'Estructura completa de clase imprimible con bloques de calentamiento, parte principal, ABS y vuelta a la calma. Lista para completar cada día en 5 minutos y llevar al gym.',
    value: '$9.000'
  }, {
    num: '03',
    title: 'Guía de Nutrición Deportiva Básica',
    desc: 'Lo que todo profe de funcional debe saber sobre nutrición para responder las preguntas de sus alumnos con autoridad. Macros, timing nutricional y suplementación básica explicados en lenguaje simple.',
    value: '$8.000'
  }, {
    num: '04',
    title: '15 Rutinas Express de 20 Minutos',
    desc: 'Rutinas completas de alta efectividad para cuando el alumno tiene poco tiempo. Sin equipamiento, con equipamiento básico y versión mixta. Listas para dar en cualquier momento.',
    value: '$10.000'
  }, {
    num: '05',
    title: 'Checklist de Seguridad y Prevención de Lesiones',
    desc: 'Protocolo completo de seguridad para cada clase: calentamiento mínimo, señales de alerta durante el WOD, posiciones de riesgo y protocolo de actuación ante lesión. Para trabajar con tranquilidad total.',
    value: '$9.000'
  }, {
    num: '06',
    title: 'Banco de Evaluaciones Físicas',
    desc: 'Test de resistencia cardiovascular, fuerza funcional y movilidad por nivel. Ficha de evaluación inicial del alumno, seguimiento trimestral y tabla de resultados esperados. Para cobrar más justificando resultados reales.',
    value: '$8.000'
  }];
  return <Section bg="dark-900" className="border-t border-dark-800" data-id="element-17">
      <div className="text-center mb-8 md:mb-16" data-id="element-18">
        <h2 className="text-3xl md:text-5xl font-display font-bold text-white mb-3 md:mb-6" data-id="element-19">
          Más los 6 Bonos Estratégicos
        </h2>
        <p className="text-lg md:text-xl text-lime-400 font-medium max-w-2xl mx-auto" data-id="element-20">
          Incluidos en todas las ofertas — sin costo extra
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-4 md:gap-6 max-w-5xl mx-auto mb-8 md:mb-16" data-id="element-21">
        {bonuses.map((bonus, i) => <div key={i} className="bg-dark-800 border border-dark-700 rounded-2xl p-5 md:p-8 flex flex-col h-full relative overflow-hidden group hover:border-lime-500/50 transition-colors" data-id="element-22">
            <div className="absolute top-0 right-0 bg-lime-500 text-dark-900 font-bold px-3 py-1 md:px-4 md:py-1 rounded-bl-xl text-xs md:text-sm z-10" data-id="element-23">
              GRATIS
            </div>

            <div className="flex items-center gap-3 md:gap-4 mb-4 md:mb-6" data-id="element-24">
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-dark-700 flex items-center justify-center border border-dark-600" data-id="element-25">
                <Gift className="w-5 h-5 md:w-6 md:h-6 text-lime-400" data-id="element-26" />
              </div>
              <div data-id="element-27">
                <div className="text-lime-500 font-bold text-xs md:text-sm tracking-wider uppercase" data-id="element-28">
                  Bono {bonus.num}
                </div>
                <h3 className="text-lg md:text-xl font-display font-bold text-white leading-tight mt-1" data-id="element-29">
                  {bonus.title}
                </h3>
              </div>
            </div>

            <p className="text-sm md:text-base text-gray-400 leading-relaxed flex-grow mb-4 md:mb-6" data-id="element-30">
              {bonus.desc}
            </p>

            <div className="mt-auto pt-4 md:pt-6 border-t border-dark-700 flex items-center justify-between" data-id="element-31">
              <span className="text-gray-500 text-xs md:text-sm uppercase tracking-wider font-bold" data-id="element-32">
                Valor normal
              </span>
              <span className="text-gray-500 line-through font-display font-bold text-base md:text-lg" data-id="element-33">
                {bonus.value}
              </span>
            </div>
          </div>)}
      </div>

      <div className="max-w-3xl mx-auto bg-gradient-to-r from-lime-600 to-lime-400 rounded-2xl p-1" data-id="element-34">
        <div className="bg-dark-900 rounded-xl p-5 md:p-8 text-center" data-id="element-35">
          <div className="text-gray-400 font-bold text-sm md:text-base uppercase tracking-widest mb-1 md:mb-2" data-id="element-36">
            Valor total de los 6 bonos
          </div>
          <div className="flex items-center justify-center gap-3 md:gap-4 mb-1 md:mb-2" data-id="element-37">
            <span className="text-2xl md:text-3xl text-gray-500 line-through font-display font-bold" data-id="element-38">
              $56.000
            </span>
            <span className="text-3xl md:text-5xl text-lime-400 font-display font-bold" data-id="element-39">
              GRATIS
            </span>
          </div>
          <p className="text-sm md:text-base text-white font-medium" data-id="element-40">
            Incluidos siempre con tu compra hoy.
          </p>
        </div>
      </div>
    </Section>;
}